export default __webpack_public_path__ + "static/media/family3.43e57482.svg";